export default "__VITE_ASSET__ea9d6c9f__"